import { updateObject } from "../../helpers/utility.helper";
import IIAQDevicesState from "../models/IIAQDevicesState";
import { initialState } from "../state/iaqDevices.state";
import iaqDevicesType from "../types/iaqDevices.type";

const getIAQDevicesStart = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqDevicesList: updateObject(
      oldState.iaqDevicesList,
      {
        data: [],
        error: null,
        loading: true,
        success: false,
      },
    ),
  });
};

const getIAQDevicesSuccess = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqDevicesList: updateObject(
      oldState.iaqDevicesList,
      {
        data: action.payload,
        error: null,
        success: true,
        loading: false,
      },
    ),
  });
};

const getIAQDevicesError = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqDevicesList: updateObject(
      oldState.iaqDevicesList,
      {
        error: action.payload,
        success: false,
        loading: false,
      },
    ),
  });
};

const resetIAQDevices = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqDevicesList: updateObject(
      oldState.iaqDevicesList,
      {
        data: initialState.iaqDevicesList.data,
        error: null,
        success: true,
        loading: false,
      },
    ),
  });
};

const getIAQLegendDetailsStart = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqLegendDetailsVM: updateObject(
      oldState.iaqLegendDetailsVM,
      {
        error: null,
        loading: true,
        success: false,
      },
    ),
  });
};

const getIAQLegendDetailsSuccess = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqLegendDetailsVM: updateObject(
      oldState.iaqLegendDetailsVM,
      {
        data: action.payload,
        error: null,
        success: true,
        loading: false,
      },
    ),
  });
};

const getIAQLegendDetailsError = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqLegendDetailsVM: updateObject(
      oldState.iaqLegendDetailsVM,
      {
        error: action.payload,
        success: false,
        loading: false,
      },
    ),
  });
};

const resetIAQLegendDetails = (
  oldState: IIAQDevicesState,
  action: any,
) => {
  return updateObject(oldState, {
    iaqLegendDetailsVM: updateObject(
      oldState.iaqLegendDetailsVM,
      {
        data: initialState.iaqLegendDetailsVM.data,
        error: null,
        success: true,
        loading: false,
      },
    ),
  });
};

const getIAQSensorFilterStart = (oldState: IIAQDevicesState, action: any) => {
  return updateObject(oldState, {
    dashboardSensorsFilter: updateObject(oldState.dashboardSensorsFilter, {
      loading: true
    })
  });
};

const getIAQSensorFilterSuccess = (oldState: IIAQDevicesState, action: any) => {

  return updateObject(oldState, {
    dashboardSensorsFilter: updateObject(oldState.dashboardSensorsFilter, {
      sensor: action.payload,
      error: null,
      loading: false
    })
  });
}

const getIAQSensorFilterError = (oldState: IIAQDevicesState, action: any) => {
  return updateObject(oldState, {
    dashboardSensorsFilter: updateObject(oldState.dashboardSensorsFilter, {
      sensor: null,
      error: 'Some Error Occured',
      loading: false
    })
  });
};

const resetIAQSensorFilterState = (oldState: IIAQDevicesState, action: any) => {
  return updateObject(oldState, {
    dashboardSensorsFilter: updateObject(oldState.dashboardSensorsFilter, {
      sensor: initialState.dashboardSensorsFilter.sensor,
      error: null,
      loading: false,
    },
    ),
  });
};

const iaqDevicesReducer = (
  oldState: IIAQDevicesState = initialState,
  action: any,
) => {
  switch (action.type) {
    case iaqDevicesType.GET_IAQ_DEVICES_START:
      return getIAQDevicesStart(oldState, action);
    case iaqDevicesType.GET_IAQ_DEVICES_SUCCESS:
      return getIAQDevicesSuccess(oldState, action);
    case iaqDevicesType.GET_IAQ_DEVICES_ERROR:
      return getIAQDevicesError(oldState, action);
    case iaqDevicesType.RESET_IAQ_DEVICES:
      return resetIAQDevices(oldState, action);
    case iaqDevicesType.GET_IAQ_LEGENDS_DETAILS_START:
      return getIAQLegendDetailsStart(oldState, action);
    case iaqDevicesType.GET_IAQ_LEGENDS_DETAILS_SUCCESS:
      return getIAQLegendDetailsSuccess(oldState, action);
    case iaqDevicesType.GET_IAQ_LEGENDS_DETAILS_ERROR:
      return getIAQLegendDetailsError(oldState, action);
    case iaqDevicesType.RESET_IAQ_LEGENDS_DETAILS:
      return resetIAQLegendDetails(oldState, action);
    case iaqDevicesType.GET_IAQ_SENSOR_FILTER_START: return getIAQSensorFilterStart(oldState, action);
    case iaqDevicesType.GET_IAQ_SENSOR_FILTER_SUCCESS: return getIAQSensorFilterSuccess(oldState, action);
    case iaqDevicesType.GET_IAQ_SENSOR_FILTER_ERROR: return getIAQSensorFilterError(oldState, action);
    case iaqDevicesType.RESET_IAQ_SENSOR_FILTER_STATE: return resetIAQSensorFilterState(oldState, action);
    default:
      return oldState;
  }
};
export default iaqDevicesReducer;
